import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ASkeleton = _resolveComponent("ASkeleton")!

  return (_openBlock(), _createBlock(_component_ASkeleton, {
    active: _ctx.active,
    paragraph: _ctx.paragraph
  }, null, 8, ["active", "paragraph"]))
}